<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid" />Tournament : <span class="font-weight-bold"> {{tournament.name}} </span>
      </slot>
      <div class="float-right">
          <button class="btn btn-success" @click="userEntryModal=true">Enter User to Tournament</button>
      </div>
    </CCardHeader>
    <CCardBody>
      <v-client-table :data="ranking" :columns="columns" :options="options">
        <template slot="has_played" slot-scope="props">
          <div>
            <router-link :to="{ name: 'TournamentEdit', params: {id: props.row.id}}">
              <span>
                  <CBadge v-if="props.row.has_played" color="success">Played</CBadge>
                <CBadge v-else color="warning">Not Played</CBadge>
              </span>
            </router-link>
          </div>
        </template>
        <template slot="is_rewarded" slot-scope="props">
          <div>
              <span v-if="props.row.position<=tournament.prize_count">
                <CBadge v-if="props.row.is_rewarded" color="success">Rewarded</CBadge>
                <CBadge v-else color="warning">Pending</CBadge>
              </span>
          </div>
        </template>
        <template slot="is_subscribed" slot-scope="props">
          <div>
              <span v-if="props.row.is_subscribed">
                <CBadge v-if="props.row.is_subscribed=='subscribed'" color="success">Subscribed</CBadge>
                <CBadge v-else color="warning">Unsubscribed</CBadge>
              </span>
          </div>
        </template>
         <template slot="action" slot-scope="props">
          <div>


            <router-link :to="`/users/show/${props.row.user_id}`" target="_blank">
              <span
                class="btn btn-primary btn-sm m-1"
                data-toggle="tooltip"
                data-placement="top"
                title="Go to Profile"
              >
                <CIcon name="cil-magnifying-glass" size="sm" />
              </span>
            </router-link>


            <button
              @click="ModalScoreEdit(props.row.user_id, props.row.name, props.row.points, props.row.time_saved, props.row.has_played)"
              class="btn btn-info btn-sm m-1"
              data-toggle="tooltip"
              title="Edit Score"
              :href="props.row.user_id"
            >
              <i class="fa fa-trophy"></i>
            </button>


            <button
                @click="amountInput(props.row.user_id)"
                class="btn btn-primary btn-sm m-1"
                data-toggle="tooltip"
                title="Send Gratification"
                :href="props.row.user_id"
                v-if="(props.row.is_rewarded != '1') && (props.row.position<=tournament.prize_count)"
            >
              <i class="fa fa-trophy"></i>
            </button>
          </div>
         </template>
      </v-client-table>


      <CModal title="Edit Score" :show.sync="scoreEditModal">
        <CRow>

          <CCol sm="12">
            <label>Participant's Name : <b>{{this.new_score.name}}</b></label>
            <CInput
              label="Score"
              placeholder="Enter Score"
              v-model="new_score.score"
            />
          </CCol>

          <CCol sm="12">
            <CInput
              label="Time Saved"
              placeholder="Enter Saved Time"
              v-model="new_score.time_saved"
            />
          </CCol>

          <CCol sm="12">
            <CButton @click="editScore" color="primary">
              <CIcon name="cil-check-circle" />Update Score
            </CButton>
          </CCol>

        </CRow>
      </CModal>


      <CModal title="Edit Score" :show.sync="userEntryModal">
        <CRow>
          <CCol sm="12">
            <CInput
              label="User Phone"
              placeholder="Enter User Phone Number"
              v-model="force_entry_user_phone"
            />
          </CCol>
          <CCol sm="12">
            <CButton @click="entryUser" color="primary">
              <CIcon name="cil-check-circle" />Enter User to Tournament
            </CButton>
          </CCol>
        </CRow>
      </CModal>


      <CModal title="Send Gratification" :show.sync="rechargeModalShow">
        <CRow>
          <CCol sm="12">
            <label>Gratification Type</label>
              <select class="form-control" v-model="gratification_type">
                <option value="manual">Manual</option>
                <option value="recharge">Recharge</option>
              </select>
            <br>
          </CCol>
          <CCol sm="12" v-show="gratification_type==='recharge'">
            <CInput
                label="Recharge Amount"
                placeholder="Enter Recharge Amount"
                v-model="recharge_amount"
            />
          </CCol>
          <CCol sm="12" v-show="gratification_type==='manual'">
            <CInput
                label="Enter Reward"
                placeholder="Enter Reward"
                v-model="manual_reward"
            />
          </CCol>
          <CCol sm="12">
            <CButton @click="recharge" color="primary">
              <CIcon name="cil-check-circle" />Give Prize
            </CButton>
          </CCol>
        </CRow>
      </CModal>

    </CCardBody>
  </CCard>
</template>

<script>
import axios from "axios";

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "TournamentRanking",
  data() {
    return {
      rechargeModalShow: false,
      rechargee: "",
      recharge_amount: 0,
      tournament: {},
      ranking: [],
      new_score : {},
      loading: false,
      gratification_type: 'recharge',
      manual_reward: '',
      scoreEditModal: false,
      userEntryModal : false,
      force_entry_user_phone: '',
      columns: ["position", "name", "phone","has_played", "points", "tournament_played", "payments","is_subscribed","is_rewarded","reward_type","reward", "action"],
      options: {
        pagination: {nav: "fixed"},
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    }
  },
  created() {
    this.getRanking();
  },
  methods: {
    getRanking() {
      this.$axios
          .post(`${ADMIN_URL}/tournaments/ranking`,{
            tournament_id : this.$route.params.id,
            all           : true
          })
          .then((response) => {
            this.tournament = response.data.tournament;
            this.ranking = response.data.ranking;
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    ModalScoreEdit(id,name,score,time,has_played) {
      this.new_score.id = id;
      this.new_score.name = name;
      this.new_score.score = score;
      this.new_score.time_saved = time;
      this.new_score.has_played = has_played;
      this.scoreEditModal = true;
    },
    editScore() {
      this.$swal({
        title: "Are you sure?",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      })
        .then((result) => {
          if (result.value) {
            this.confirmUpdate();
          }
        })
        .catch((error) => {
          console.log('Sweetalert ERROR',error);
        });
    },
    confirmUpdate() {
      this.loading = true;
      this.scoreEditModal = false;
      this.$axios
        .post(`${ADMIN_URL}/tournaments/update-score`, {
          user_id: this.new_score.id,
          tournament_id:  this.$route.params.id,
          score : this.new_score.score,
          time_saved : this.new_score.time_saved,
          played : this.new_score.has_played
        })
        .then((response) => {
          this.loading = false;
          console.log(response.data)

          if (response.data.success) {
            this.$swal("Success", response.data.message, "success");
            this.getRanking()
          } else {
            this.$swal("Errora", response.data.message, "error");
          }
        })
        .catch((error) => {
          this.loading = false;
             console.log(error.response.data)
          this.$swal("Errorb", error.response.data.description, "error");
        });
    },
    entryUser() {
      this.$axios
        .post(`${ADMIN_URL}/tournaments/force-entry`, {
          phone: this.force_entry_user_phone,
          tournament_id:  this.$route.params.id
        })
        .then((response) => {
          this.loading = false;
          console.log(response.data)

          if (response.data.success) {
            this.$swal("Success", response.data.message, "success");
            this.getRanking()
          } else {
            this.$swal("Error", response.data.message, "error");
          }
        })
        .catch((error) => {
          this.loading = false;
             console.log(error.response.data)
          this.$swal("Error", error.response.data.message, "error");
        });

    },
    amountInput(id) {
      this.rechargee = id;
      this.rechargeModalShow = true;
      console.log("checking", this.rechargee);
    },
    recharge() {
      if(
          (this.gratification_type =='recharge' && this.recharge_amount==0)
          || (this.gratification_type == 'manual' && this.manual_reward=='')
      ){
        this.$swal("Error", 'Please provide input properly', "error");
        return;
      }
      this.$swal({
        title: "Are you sure?",
        type: "warning",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      })
          .then((result) => {
            if (result.value) {
              this.confirmRecharge();
            }
          })
          .catch((error) => {
            //console.log('Sweetalert ERROR');
          });
    },
    confirmRecharge() {
      this.loading = true;
      this.rechargeModalShow = false;
      axios
          .post(`${ADMIN_URL}/tournament-participant-recharge`, {
            tournament_id: this.$route.params.id,
            amount: this.recharge_amount,
            gratification_type: this.gratification_type,
            user_id: this.rechargee,
            reward: this.manual_reward
          })
          .then((response) => {
            this.loading = false;

            if (response.data.success == true){
              this.$swal("Success", response.data.message, "success").then(function() {
                window.location.reload();
              });
              this.getLeaderBoard()
            } else {
              this.$swal("Error", response.data.message, "error").then(function() {
                window.location.reload();
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$swal("Error", error.response.data.message, "error").then(function() {
              window.location.reload();
            });
          });
    }

  }
}
</script>

<style scoped>

</style>
